var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCampaignIconActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 21.43 15.89",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{clip-path:url(#clip-path);}.cls-3{fill:#39af4f;fill-rule:evenodd;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 21.43,
    height: 15.89
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Untitled-1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M19.7.11a1.62,1.62,0,0,0-1.62,1.61,1.66,1.66,0,0,0,.19.74L13.59,8.81a1.54,1.54,0,0,0-.74-.19,1.58,1.58,0,0,0-.86.25l-2.37-2a1.49,1.49,0,0,0,0-.21,1.62,1.62,0,1,0-3.23,0,1.58,1.58,0,0,0,0,.38L2.11,12.63a2,2,0,0,0-.43-.06A1.62,1.62,0,1,0,3.3,14.18a1.69,1.69,0,0,0-.13-.63L7.38,8.17A1.75,1.75,0,0,0,8,8.3a1.53,1.53,0,0,0,.82-.23l2.4,2c0,.05,0,.1,0,.16a1.62,1.62,0,1,0,3.2-.23l5-6.7a1.55,1.55,0,0,0,.31,0,1.62,1.62,0,1,0,0-3.23"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCampaignIconActive);
export default __webpack_public_path__ + "static/media/campaign-icon-active.6d44f5957c76a5734593e68bb1564a18.svg";
export { ForwardRef as ReactComponent };